// extracted by css-extract-rspack-plugin
export default {"root":"lxfhzS","body-wrapper":"CgtWxd","bodyWrapper":"CgtWxd","big":"cccImY","postfix":"mrsH8s","small":"iwnwvM","multiline":"Qepxm4","body-node":"_OGjem","bodyNode":"_OGjem"};